import { connect } from 'react-redux';

import CourseContent from 'es6/components/courses/course-content';

export function mapStateToProps({ env }) {
  let isContentCreationEnabled = false;

  const siteConfiguration = env ? env.siteConfiguration : undefined;

  if (siteConfiguration) {
    isContentCreationEnabled = siteConfiguration.features.contentCreation;
  }

  return {
    isContentCreationEnabled,
  };
}

export default connect(mapStateToProps)(CourseContent);
